import React from "react";
import styles from "./css/Button.module.css";

interface Props {
  icon: "left-side" | "no" | "right-side";
  iconComponent?: React.ElementType;
  iconSrc?: string;
  className?: string;
  text: string;
  disabled?: boolean;
  ready?: boolean;
  iconColorType?: "stroke" | "fill" | "text";
  size?: "small" | "large" | "fit";
  loading?: boolean; 
  id: string;
  onClick: () => void;
  space?: boolean
  color?: "gray" | "red" | "blue" | "skyBlue";
  ariaLabel?: string;
  textClassName?: string;
  children?: React.ReactNode;
  popupstyle?: "gray" | "red";

}

export const Button: React.FC<Props> = ({
  icon,
  iconComponent: IconComponent,
  iconSrc,
  className,
  text,
  disabled,
  ready,
  size = "",
  iconColorType,
  loading,
  id,
  onClick,
  space = false,
  color = "",
  ariaLabel,
  textClassName,
  children,
  popupstyle
}) => {
  const handleClick = () => {
    if (!loading && !disabled) {
      onClick();
    }
  };
  return (
    <button
      className={`${styles.button} ${loading ? styles.loading : ""} ${disabled ? styles.buttonDisabled : ready ? styles.buttonReady : ""} 
      ${className} ${styles[size]} ${space? styles.space : ''} ${color === "gray" && ready ? styles.readyGray: ''} ${color === "blue" && ready ? styles.readyBlue: ''} 
      ${color === "red" && ready ? styles.readyRed: ''} ${color === "skyBlue" ? styles.skyBlue : ''} ${popupstyle === "gray" ? styles.popupGray : popupstyle === "red" ? styles.popupRed : ''}`}
      onClick={handleClick}
      data-testid={id}
      dir="ltr"
      disabled={disabled || loading}
      role="button"
      aria-label={ariaLabel || text}
      aria-disabled={disabled || loading}
      aria-busy={loading}
    >
      <>
        {loading && (
          <div className={styles.loaderContainer}>
            <div
              className={`${styles.loader} ${ready ? styles.ready : ""} ${color === "gray" && ready ? styles.readyGray: ''} ${color === "blue" && ready ? styles.readyBlue: ''} ${color === "red" && ready ? styles.readyRed: ''} ${popupstyle === "gray" ? styles.popupGray : popupstyle === "red" ? styles.popupRed : ''}`}
            ></div>
          </div>
        )}
        {icon === "left-side" && (IconComponent || iconSrc) && (
          <div className={styles.iconContainer}>
            {IconComponent ? (
              <IconComponent
                color={color === "blue" && ready ? "#0068F5" : undefined}
                className={`${styles.icon} ${loading ? styles.notShow : ""} ${iconColorType === "fill" ? styles.fillColor : iconColorType === "stroke" ? styles.strokeColor : styles.textColor} ${disabled ? styles.iconDisabled : ready ? styles.iconReady : ""} ${color === "blue" && ready ? styles.iconReadyBlue : ''}`}
              />
            ) : (
              <img
                src={iconSrc}
                alt=""
                className={`${styles.icon} ${loading ? styles.notShow : ""} ${iconColorType === "fill" ? styles.fillColor : iconColorType === "stroke" ? styles.strokeColor : styles.textColor} ${disabled ? styles.iconDisabled : ready ? styles.iconReady : ""}`}
              />
            )}
          </div>
        )}

        {text && <div
          className={`${styles.text} ${icon !== "no" ? styles.rightText: ""} ${disabled ? styles.disableText : ready ? styles.textReady : ""} ${color === "gray" && ready ? styles.readyGray: ''} ${color === "blue" && ready ? styles.readyBlue: ''} ${color === "red" && ready ? styles.readyRed: ''} ${color === "skyBlue" ? styles.skyBlue : ''} ${popupstyle === "gray" ? styles.popupGray : popupstyle === "red" ? styles.popupRed : ''} ${loading ? styles.notShow : ""} ${textClassName}`}
        >
          {text}
        </div>}

        {icon === "right-side" && (IconComponent || iconSrc) && (
          <div className={styles.iconContainer}>
            {IconComponent ? (
              <IconComponent
                color={color === "blue" && ready ? "#0068F5" : undefined}
                className={`${styles.icon} ${loading ? styles.notShow : ""} ${disabled ? styles.iconDisabled : ready ? styles.iconReady : ""} ${iconColorType === "fill" ? styles.fillColor : iconColorType === "stroke" ? styles.strokeColor : styles.textColor}`}
              />
            ) : (
              <img
                src={iconSrc}
                alt=""
                className={`${styles.icon} ${loading ? styles.notShow : ""} ${disabled ? styles.iconDisabled : ready ? styles.iconReady : ""} ${iconColorType === "fill" ? styles.fillColor : iconColorType === "stroke" ? styles.strokeColor : styles.textColor}`}
              />
            )}
          </div>
        )}
      </>
      {children}
    </button>
  );
};
